// extracted by mini-css-extract-plugin
export default {"deactivatedUser":"styles_deactivatedUser__Jxg9Y","title":"styles_title__VR7m8","deactivated":"styles_deactivated__ft7xN"};